// src/utils/antiDebug.js

export default function setupAntiDebug() {
  // 禁用右键菜单
  document.addEventListener('contextmenu', e => e.preventDefault())

  // 禁用快捷键
  document.addEventListener('keydown', function (e) {
    if (
      e.key === 'F12' ||
      (e.ctrlKey && e.shiftKey && ['I', 'J', 'C'].includes(e.key)) ||
      (e.ctrlKey && e.key === 'U')
    ) {
      e.preventDefault()
      return false
    }
  })

  // 检测 DevTools 打开
  let devtoolsCheck = () => {
    const start = new Date()
    debugger
    const end = new Date()
    if (end - start > 160) {
      alert('请关闭开发者工具后再使用本系统')
      window.location.href = 'about:blank'
    }
  }
  setInterval(devtoolsCheck, 1000)
}
